import React, { Fragment, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { BoxArrowUpRight, Trash } from 'react-bootstrap-icons';
import DeletePotentialInfluencerModal from './DeletePotentialInfluencerModal';
import { TABLE_COLUMNS } from './potentialInfluencerConstants'

// Matches the create/destroy badge colors used by AuditLog/AuditLogParts/AuditLogEntry.jsx.
const INFLUENCER_CREATED_BADGE_CLASSES = {
  true: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  false: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
}

export default function PotentialInfluencerItem({ potentialInfluencer, getPotentialInfluencers }) {
  const [deletePotentialInfluencerModalOpen, setDeletePotentialInfluencerModalOpen] = useState(false)
  const location = useLocation()

  return (
    <Fragment>
      <div className="flex items-center gap-4 px-4 py-3 border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter last:border-b-0 hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter transition-colors">
        <span className={`${TABLE_COLUMNS.id} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey`}>{potentialInfluencer.id}</span>
        <span className={`${TABLE_COLUMNS.name} text-sm font-semibold text-rb-black dark:text-white truncate`}>{potentialInfluencer.name}</span>
        <span title={potentialInfluencer.email} className={`${TABLE_COLUMNS.email} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate`}>{potentialInfluencer.email}</span>
        <span className={`${TABLE_COLUMNS.created} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey`}>{potentialInfluencer.created_at?.split('T')[0]}</span>
        <span className={TABLE_COLUMNS.influencerCreated}>
          <span className={`inline-flex items-center justify-center w-16 px-2 py-0.5 rounded-full text-xs font-semibold ${INFLUENCER_CREATED_BADGE_CLASSES[!!potentialInfluencer.influencer_created]}`}>
            {potentialInfluencer.influencer_created ? 'Yes' : 'No'}
          </span>
        </span>
        <span className={`${TABLE_COLUMNS.influencerCreatedAt} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey`}>{potentialInfluencer.influencer_created_at?.split('T')[0]}</span>
        <span className={`${TABLE_COLUMNS.actions} gap-1`}>
          <Link
            to={`/project_manager/potential_influencers/${potentialInfluencer.id}`}
            state={{ listSearch: location.search }}
            title="View profile"
            className="flex justify-center h-8 items-center w-8 text-rb-mat-grey dark:text-rb-dark-mode-text-grey hover:text-rb-green hover:bg-rb-soft-green dark:hover:bg-rb-green/10 dark:hover:text-rb-green rounded-full transition-colors"
          >
            <BoxArrowUpRight />
          </Link>
          <button
            title="Delete"
            className="flex justify-center h-8 items-center w-8 text-rb-mat-grey dark:text-rb-dark-mode-text-grey hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 dark:hover:text-red-400 rounded-full transition-colors"
            onClick={() => setDeletePotentialInfluencerModalOpen(true)}
          >
            <Trash />
          </button>
        </span>
      </div>
      {deletePotentialInfluencerModalOpen && <DeletePotentialInfluencerModal isOpen={deletePotentialInfluencerModalOpen} setOpenDeleteModal={setDeletePotentialInfluencerModalOpen} potentialInfluencer={potentialInfluencer} getPotentialInfluencers={getPotentialInfluencers} />}
    </Fragment>
  )
}
